export default {
  communicateCenter_my_circle: '我的圈子',
  communicateCenter_more_circle: '更多圈子',
  communicateCenter_first_more_circle: '去關註你的第一個圈子吧',
  communicateCenter_no_dynamic: '還沒有動態',
  communicateCenter_no_nickname: '暫無昵稱',
  communicateCenter_from_circle: '來自圈子',
  communicateCenter_total_pics: '共{total}張圖片',
  communicateCenter_reply: '個帖子',
  communicateCenter_comment: '{commentCount}個評論',
  communicateCenter_collect: '{collectCount}個收藏',
  communicateCenter_like: '{likeCount}個贊',
}
